import { __awaiter, __generator } from "tslib";
export function loadAlbacross(analytics) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var reveal;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!window.AlbacrossReveal) {
                        return [2 /*return*/];
                    }
                    reveal = window.AlbacrossReveal.company;
                    if (!reveal || !reveal.url || ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website)) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, analytics.group(null, {
                            website: reveal.url,
                            intentSource: 'albacross',
                            name: reveal.name || undefined,
                            country: reveal.country || undefined,
                            industry: reveal.linkedin_industry_code
                                ? reveal.linkedin_industry_code.category
                                : undefined,
                            number_of_employees: reveal.employees
                                ? reveal.employees.from + ' - ' + reveal.employees.to
                                : undefined,
                            annual_revenue: reveal.financial_report
                                ? reveal.financial_report.from + ' - ' + reveal.financial_report.to
                                : undefined,
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=albacross.js.map